<template>
  <div class="criteria-container">
    <div v-if="!isEditing && saved" class="row align-items-center">
      <div class="col-12 col-md-10">
        <label class="input-display d-block">
          Describa los criterios y procedimientos que se utilizarán para evaluar
          el progreso del estudiante:
        </label>
        <span class="text-format">{{ criteriaAndProcedures }}</span>
      </div>
      <div v-if="!readOnly" class="col-12 col-md-2 text-right">
        <drop-down class="criterias-action" :items="actionItems" />
      </div>
    </div>
    <div v-else class="row">
      <div class="col-12">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            id="comment"
            v-model="editedCriteriaAndProcedures"
            class="criteria-container__text-area"
            :count-classes="['d-block', 'small-counter']"
            custom-error-msg="Favor escribir una descripción de criterios y procedimientos"
            :error="errors[0]"
            label="Describa los criterios y procedimientos que se utilizarán para evaluar el progreso del estudiante:"
            :maxlength="3000"
            name="comment"
            show-char-count
          />
        </validation-provider>
      </div>
      <div class="col-12 mt-3 mt-md-2 d-flex justify-content-end">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="cancelHandler"
        />
        <action-button
          i="fa fa-save"
          text="Guardar"
          variant="success"
          @click="saveHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from 'dropdown';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

export default {
  name: 'CriteriaAndProceduresSection',
  components: {
    DropDown,
    CustomTextArea,
    ActionButton,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    criteriaAndProcedures: {
      type: String,
      default: () => '',
    },
  },
  data: () => ({
    oldCriteriaAndProcedures: null,
    isEditing: false,
    saved: false,
  }),
  watch: {
    criteriaAndProcedures: {
      handler(newVal) {
        if (!this.isEditing) {
          this.saved = newVal?.length > 0;
        }
      },
      immediate: true,
    },
  },
  computed: {
    editedCriteriaAndProcedures: {
      get() {
        return this.criteriaAndProcedures;
      },
      set(value) {
        this.isEditing = true;
        this.$emit('update:criteriaAndProcedures', value);
      },
    },
    actionItems() {
      return [
        {
          label: 'Editar',
          icon: 'fas fa-edit color-primary-1',
          border: 'bottom',
          click: () => this.editHandler(),
        },
      ];
    },
  },
  methods: {
    saveHandler() {
      this.saved = true;
      this.isEditing = false;
      this.oldCriteriaAndProcedures = null;
      this.$emit('save');
    },
    editHandler() {
      this.isEditing = true;
      this.oldCriteriaAndProcedures = this.criteriaAndProcedures;
    },
    cancelHandler() {
      this.saved = !!this.oldCriteriaAndProcedures?.length;
      this.isEditing = false;
      this.editedCriteriaAndProcedures = this.oldCriteriaAndProcedures;
    },
    setFlags() {
      this.saved = true;
      this.isEditing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/_colors.scss';

.criteria-container {
  padding: 0 0.8rem;
  ::v-deep &__text-area {
    .small-counter {
      font-size: 0.8rem;
      color: map-get($colors, 'gray-6');
    }
  }

  .input-display {
    font-size: 0.875rem;
    color: map-get($colors, 'gray-6');
    font-weight: bold;
  }

  .text-format {
    overflow-wrap: break-word;
    text-align: justify;
  }

  @media only screen and (max-width: 768px) {
    ::v-deep .criterias-action {
      .btn {
        margin-top: 0.8rem;
        width: 100%;
      }
    }
  }
}
</style>
